export default __webpack_public_path__ + "static/media/remove.12cad479.svg";